import {ADD_MESSAGE, REMOVE_MESSAGE} from '../constants/actionTypes';
import defaultStoreValues from '../../../constants/defaultStoreValues';

export default (state, action) => {

    switch (action.type) {
        case ADD_MESSAGE:
            return {
                ...state,
                messageBar: action.message
            };
        case REMOVE_MESSAGE:

            return {
                ...state,
                messageBar: defaultStoreValues.messageBar
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/reducers/messageBarReducer.js